import { Button } from 'antd'
import { ColumnFilterWrapperProps } from './types'

const ColumnFilterWrapper: React.FC<ColumnFilterWrapperProps> = ({
  children,
  onOk,
  onReset,
  selectedKeys,
  clearFilters,
  confirm,
}) => {
  return (
    <>
      <li className="ant-dropdown-menu-item">{children}</li>
      <div className="ant-table-filter-dropdown-btns">
        <Button
          disabled={!selectedKeys.length}
          size="small"
          type="link"
          onClick={() => {
            clearFilters?.()
            onReset()
          }}
        >
          Reset
        </Button>
        <Button
          size="small"
          type="primary"
          onClick={() => {
            confirm()
            onOk()
          }}
        >
          OK
        </Button>
      </div>
    </>
  )
}

export default ColumnFilterWrapper
